<template>
  <div class="selct-wrap" v-if="questionList&&questionList.length>0">
    <m-header>
      <div class="m-top-box">
        <ul class="m-top-bar">
          <li class="m-bar" v-for="(item,index) in questionList" :key="index"
              :class="[{active: index === topIndex},{less:questionList.length===1}]">
          <span :class="{active: index===topIndex}">{{index + 1}}<em
              v-if="index === topIndex">、{{item.name}}</em> </span>
            <img v-if="index === 0 && index !== questionList.length-1 && index === topIndex "
                 src="../../../../public/images/personal/djxx-02.png">
            <img v-if="index!==0&& index !==questionList.length-1 && index === topIndex "
                 src="../../../../public/images/personal/djxx-03.png">
            <img v-if="index !== 0&&index === questionList.length-1 && index === topIndex"
                 src="../../../../public/images/personal/djxx-04.png">
            <i v-if="questionList.length>1&&index!==questionList.length-1&&index!==topIndex&&index!==topIndex-1"
               class="icon icon-jiantou-"></i>
          </li>
        </ul>
      </div>
    </m-header>

    <div class="m-question">
      <!--第一级--item-->
      <div class="m-card" :class="{notPass:item.motionless && !item.show}" v-for="(item,index) in dataList"
           :id="'m'+item.id"
           :key="index+item.id">
        <!--第一级--标题-->
        <div class="affix-block">
          <affix :relative-element-selector="'#m'+item.id" :offset="{top:-10, bottom: -10}">
            <div class="m-title">
              <em>{{ item.name | discardHTML }}</em><span>{{item.questionTypeName}}</span>
            </div>
          </affix>
          <div class="m-title conceal">
            <em>{{ item.name | discardHTML }}</em><span>{{item.questionTypeName}}</span>
          </div>
        </div>
        <img :src="'//demo-static-resources.tijianzhuanjia.com/wx/img/sport/'+item.id+ '.png'" alt=""
             v-if="item.questionPic" class="questionPic">
        <!--<p class="m-title" v-if="item.questionTypeCode === 'text'"><em>{{ item.name | discardHTML }}</em><span>{{item.questionTypeName}}</span></p>-->

        <!--单选题-->
        <div v-if="item.questionTypeCode === 'radio'" class="m-radio-box">
          <p v-for="(radio,radioIndex) in item.optionList" :key="radio.id+radioIndex"
             @click="getRadio(radio,index,item)"
             class="m-radio-1"
             :class="[{'m-active':radio.select},{hasPic:item.optionsPic},`numOfEachRow-${item.numOfEachRow?item.numOfEachRow:'1'}`]">
            <i class="icon icon-radiochecked-copy" v-if="radio.select"></i>
            <i class="icon icon-danxuankuang" v-else></i>
            <!--<div v-if="item.optionsPic">-->
            <span v-if="item.optionsPic">

              <div class="optionsPic"><img
                  :src="'//demo-static-resources.tijianzhuanjia.com/wx/img/sport/'+radio.id+ '.png'" alt=""></div>
              <!--</div>-->
              <div>{{radio.name}}</div>
            </span>
            <span v-else>
              {{radio.name}}
            </span>
            <span
                v-if="(radio.select||radio.show) &&radio.childrenQuestion.length>0&& radio.childrenQuestion[0].popup===1">
                  <!--v-for="(child,index) in radio.childrenQuestion[0]" :key="index">-->
              <span v-for="two in  radio.childrenQuestion[0].optionList" :key="two.id"
                    v-if="two.select&&two.questionTypeCode!=='text'"><em>--({{two.name}})</em></span>
              <span
                  v-if="radio.childrenQuestion[0].popup === 1&&radio.childrenQuestion[0].questionTypeCode==='text'"><em>--({{radio.childrenQuestion[0].txtAnswer}})</em></span>
            </span>
          </p>
        </div>
        <!--/单选题-->

        <!--多选题-->
        <div v-if="item.questionTypeCode === 'checkbox'">
          <div class="m-checkbox" v-for="(option,optionIndex) in item.optionList" :id="option.id"
               :key="option.id+optionIndex" @click="getCheckbox( option, index, item, $event)"
               :class="[{'m-active': option.select},`numOfEachRow-${item.numOfEachRow?item.numOfEachRow:'1'}`]">
            <i class="icon icon-radiochecked-copy" v-if="option.select"></i>
            <i class="icon icon-danxuankuang" v-else></i>
            {{option.name}}
            <span
                v-if="option.select&&option.childrenQuestion.length>0&&option.childrenQuestion[0].popup===1">
              <span v-for="two in  option.childrenQuestion[0].optionList" :key="two.id"
                    v-if="two.select&&two.questionTypeCode!=='text'"><em>--({{two.name}})</em></span>
              <span v-if="option.childrenQuestion[0].popup === 1&&option.childrenQuestion[0].questionTypeCode==='text'"><em>--({{option.childrenQuestion[0].txtAnswer}})</em></span>
            </span>
          </div>
        </div>
        <!--/多选题-->

        <!--问答题-->
        <p v-if="item.questionTypeCode === 'text'" class="m-input">
          <my-input v-model="item.txtAnswer" :type="item.dataType" :dataList="item"
                    :verify="['required',(item.dataValueBegin||item.dataValueEnd?'range':'')]"
                    :range="{min:item.dataValueBegin,max:item.dataValueEnd}" @input="inputComplete">
            <div slot="textLast">{{item.dataUnit}}</div>
          </my-input>
        </p>
        <!--/问答题-->
      </div>
    </div>
    <div v-if="topIndex === 0 &&allData.length>1" class="m-foot">
      <button class="btn m-btn-1" @click="next()">下一步</button>
    </div>
    <div v-if="topIndex > 0 || allData.length==1" class="m-foot">
      <button class="btn m-btn-prev" v-if=" allData.length>1" @click="prev()">上一步</button>
      <button v-if="topIndex !== allData.length - 1" class="btn m-btn-next" @click="next()">下一步</button>
      <button v-if="topIndex === allData.length - 1" class="btn m-btn-next" @click="next(true)">提交</button>
    </div>
    <!--上拉菜单--多(单)选题-->
    <van-actionsheet v-model="show" :title="pullTitle">
      <ul class="m-actions-box">
        <li class="m-actions" v-for="(item,index) in actions.optionList" :key="index"
            :class="{'actions-active': item.select}"
            @click="item.select= !item.select;crosshead(actions)"
            v-if="actions.questionTypeCode==='radio'">
          <i class="icon icon-radiochecked-copy" v-if="item.select"></i>
          {{item.name}}
        </li>
        <li class="m-actions" v-for="(item,index) in actions.optionList" :key="index"
            :class="{'actions-active': item.select}"
            @click="item.select= !item.select" v-if="actions.questionTypeCode!=='radio'">
          <i class="icon icon-right" v-if="item.select"></i>
          {{item.name}}
        </li>
        <li class="m-actions m-affirm" @click="crosshead(actions)">确定</li>
      </ul>
    </van-actionsheet>
    <van-dialog v-model="showInput" show-cancel-button :before-close="beforeClose">
      <div class="m-pop">
        <p class="m-pop-title">追问您</p>
        <div class="m-pop-cont">
          <p class="m-issue">{{inputIssue}}</p>
          <w-input placeholder="请在此输入答案" v-model="inputModel" :type="inputPopData.dataType"
                   :startNum="inputPopData.dataValueBegin" :endNum="inputPopData.dataValueEnd"
                   @input="beforeClose"></w-input>
        </div>
      </div>
    </van-dialog>
  </div>
</template>
<script>
import MHeader from '../header/m-header'
import { Actionsheet, Dialog } from 'vant'
//import roll from '@assets/script/directives/scroll'
import { Affix } from 'vue-affix'
import WInput from '../input/w-input'
import MyInput from '../input/my-input'
import jumper from '@/assets/scripts/jumper/index'
import { Loading } from '@/assets/scripts/helper'
import Vue from 'vue'

Vue.use(Actionsheet).use(Dialog)
export default {
  components: {
    MHeader,
    Affix,
    WInput,
    MyInput
  },
  data () {
    return {
      topIndex: 0, //当前页数题目
      checkboxItem: '', //多选 选中 数据
      show: false,
      showInput: false,
      answers: [], //提交答案集合
      allDataIndex: [], //下一步临时存放数据

      pullTitle: '',
      hasActions: '', //记录当前操作中含多选子题的多选题
      lastSubmit: 0, //防止用户多次点击提交
      actions: [], //记录当前操作中的多选子题

      //        topList: [], //head标题数据
      dataList: [],

      prevAnswers: [], //存储上一步数据

      inputIssue: '', // 填空题问题（弹出框）
      inputModel: '', //填空题值（弹出框）
      inputPopData: '', //填空题弹窗 题 数据
      popDataState: false, //追问提交记录
      topicIndex: 0, //记录加载已填问卷初始化的下标
      //        templateData: [], //记录初始化前的原始数据
      initEndData: {},
      userData: '',
      allData: [] //记录所有数据
    }
  },
  watch: {
    questionList (newval) {
      if (newval && newval.length > 0) {
        newval.forEach((obj) => {
          this.allData.push(JSON.parse(JSON.stringify(obj.questions)))
        })
        this.selectState()
      }
    }
  },
  props: {
    questionList: {
      type: Array
    },
    sport: {
      type: Boolean,
      default: false
    }
  },
  filters: {
    discardHTML: function (value) {
      return value.replace(/<\/*[^>\u4e00-\u9fa5]+\/*>/g, '')
    },
    titleName (val) {
      console.log(val)
      let name = ''
      let max = 10
      let showFont = {
        start: 3,
        end: 2
      }
      if (val.length >= max) {
        name = val.substring(0, showFont.start) + '...' + val.substring(val.length - showFont.end, val.length)
      } else {
        name = val
      }
      return name
    }
  },
  methods: {
    initShow (data, setType, mindex, id) {
      if (setType === 'show') {
        this.initEndData[id] = {id: id, data: data}
      }
      data.forEach((obj, i) => {
        //  获取数据并做处理
        obj.show = (obj.show === 'true')
        if (obj.questionTypeCode === 'checkbox' || obj.questionTypeCode === 'radio') {
          obj.optionList.forEach((item, n) => {
            item.select = (item.select === 'true')
            if (item.select) {
              if (item.childrenQuestion && item.childrenQuestion.length > 0 && item.childrenQuestion[0].popup === 0) { //item.childrenQuestion[0].popup === 0 追问题只能配置一个
                obj.show = true
                this.initShow(item.childrenQuestion, 'show', i, obj.id)
              } else if (item.childrenQuestion && item.childrenQuestion.length > 0) {
                if (item.childrenQuestion[0].questionTypeCode !== 'text') {
                  item.childrenQuestion[0].show = false
                  item.childrenQuestion[0].optionList.forEach($obj => {
                    console.log($obj, item.childrenQuestion)
                    if ($obj.select === 'true') {
                      $obj.select = true
                      item.childrenQuestion[0].show = true
                    } else {
                      $obj.select = false
                    }
                  })
                  item.select = item.childrenQuestion[0].show
                } else {
                  if (item.childrenQuestion[0].txtAnswer) { item.childrenQuestion[0].show = true } else {
                    item.select = false
                    item.childrenQuestion[0].show = false
                  }
                }
                //
              }
            } else {
              if (item.childrenQuestion && item.childrenQuestion.length > 0) {
                item.show = false
                this.eliminate(item.childrenQuestion)
              }
            }
          })
        } else if (obj.questionTypeCode === 'text') {
          if (obj.textAnswer && !obj.txtAnswer) obj.txtAnswer = obj.textAnswer
          if (!obj.txtAnswer) {
            obj.show = false
          }
        }
      })
    },
    //    切换tab
    async selectState () {
      window.scrollTo(0, 0)
      this.dataList = this.allData[this.topIndex]
      if (!this.allDataIndex.includes(this.topIndex)) {
        this.allDataIndex.push(this.topIndex)
        await this.initShow(this.dataList)
        for (let item in this.initEndData) {
          this.dataList.forEach((obj, i) => {
            if (obj.id === item) {
              this.dataList.splice(i + 1, 0, ...this.initEndData[item].data)
            }
          })
        }
      }
    },

    crosshead (data) { //   追问题目确认
      let state = this.actions.optionList.some(obj => { return obj.select })
      if (state) {
        console.log(data)
        if (this.hasActions.parent.questionTypeCode === 'radio') { //父级题目单选 (当前题目为单选)
          //            this.hasActions.parent
          this.hasActions.parent.optionList.forEach(obj => {
            obj.select = false
            if (obj.id !== this.hasActions.child.id && obj.childrenQuestion && obj.childrenQuestion.length > 0) {
              this.eliminate([obj.childrenQuestion])
            }
          })
        } else { // //父级题目多选 (当前题目为单选)
          if (this.hasActions.child.exclusive === 1) {
            this.eliminate([this.hasActions.parent])
          } else {
            this.hasActions.parent.optionList.forEach(obj => {
              if (obj.exclusive === 1) {
                obj.select = false
                if (obj.childrenQuestion && obj.childrenQuestion.length > 0) {
                  this.eliminate(obj.childrenQuestion)
                }
              }
            })
          }
        }
        this.hasActions.parent.show = true
        this.hasActions.child.select = true
        this.hasActions.child.childrenQuestion[0].select = true
      }
      this.show = false
    },

    eliminate (questionList, del) { //清除选项
      questionList.forEach(question => {
        question.show = false
        if (!del) {
          if (question.questionTypeCode !== 'text') {
            question.optionList.forEach(obj => {
              obj.select = false
              if (obj.childrenQuestion && obj.childrenQuestion.length > 0 && obj.childrenQuestion[0].popup === 0) {
                this.eliminate(obj.childrenQuestion)
                for (let i = 0; i < this.dataList.length; i++) {
                  let item = this.dataList[i]
                  if (obj.childrenQuestion.some(data => { return data.id === item.id })) {
                    this.dataList.splice(i, 1)
                    i--
                  }
                }
              } else if (obj.childrenQuestion && obj.childrenQuestion.length > 0 && obj.childrenQuestion[0].popup === 1) {
                this.eliminate(obj.childrenQuestion)
              }
            })
          } else {
            question.txtAnswer = ''
          }
        } else {
          for (let i = 0; i < this.dataList.length; i++) {
            let item = this.dataList[i]
            if (question.id === item.id) {
              this.dataList.splice(i, 1)
              i--
            }
          }
        }
      })
    },

    getRadio (item, index, list) {
      this.checkboxItem = item
      if (!item.select) {
        if ((item.childrenQuestion && item.childrenQuestion.length > 0 && item.childrenQuestion[0].popup === 0) || item.childrenQuestion.length <= 0) {
          if (index < this.dataList.length - 1) {
            jumper.jumpByElementId('m' + this.dataList[index + 1].id)
          }
          let dataIndex = index
          this.eliminate([list])
          if (item.childrenQuestion && item.childrenQuestion.length > 0) {
            item.childrenQuestion.forEach((obj) => {
              if (obj.questionTypeCode === 'text') {
                obj.txtAnswer = ''
              } else {
                obj.optionList.forEach((item, n) => {
                  item.select = false
                })
              }
              obj.show = false
              dataIndex += 1
              this.dataList.splice(dataIndex, 0, obj)
            })
          }
          item.select = true
          list.show = true
        } else if (item.childrenQuestion && item.childrenQuestion.length > 0 && item.childrenQuestion[0].popup === 1) {
          this.showFollowUp(item, list)
        }
      } else if (item.select) {
        item.select = false
        list.show = false
        if (item.childrenQuestion && item.childrenQuestion.length > 0) {
          this.eliminate([list])
        }
      }
    },

    //处理追问题目
    showFollowUp (item, list) {
      this.hasActions = {parent: list, child: item}
      if (!item.select && item.childrenQuestion[0].questionTypeCode !== 'text') {
        this.actions = []
        this.show = true

        this.pullTitle = `${item.childrenQuestion[0].name}(${item.childrenQuestion[0].questionTypeName})`
        this.actions = item.childrenQuestion[0]
      }
      if (!item.select && item.childrenQuestion.length && item.childrenQuestion[0].questionTypeCode === 'text') {
        this.inputPopData = item.childrenQuestion[0]
        this.inputModel = ''
        this.showInput = true
        this.inputIssue = item.childrenQuestion[0].name
      }
    },

    getCheckbox (item, index, list, event) {
      this.checkboxItem = item
      if (!item.select) {
        if (item.childrenQuestion.length <= 0 || (item.childrenQuestion.length > 0 && item.childrenQuestion[0].popup === 0)) {
          if (item.exclusive === 1) {
            this.eliminate([list])
          } else {
            list.optionList.forEach((obj) => {
              if (obj.select && obj.exclusive === 1) {
                if (obj.childrenQuestion && obj.childrenQuestion.length > 0) {
                  this.eliminate(obj.childrenQuestion)
                }
                obj.select = false
              }
            })
          }
          list.show = true
          item.select = true
        }

        if (item.childrenQuestion && item.childrenQuestion.length > 0 && item.childrenQuestion[0].popup === 0) {
          console.log(this.dataList, index)
          let optionIndex = index
          //            this.dataList.forEach(obj => {
          //              if (obj.parentId && obj.parentId === list.id) {
          //                optionIndex += 1
          //              }
          //            })
          item.childrenQuestion.forEach((data) => {
            optionIndex += 1
            this.dataList.splice(optionIndex, 0, data)
          })
        } else if (item.childrenQuestion && item.childrenQuestion.length > 0 && item.childrenQuestion[0].popup === 1) {
          this.showFollowUp(item, list)
        }
      } else if (item.select) {
        //   取消

        item.select = false
        if (item.childrenQuestion && item.childrenQuestion.length && item.childrenQuestion[0].popup === 1) {
          this.eliminate(item.childrenQuestion)
        } else if (item.childrenQuestion && item.childrenQuestion.length) { this.eliminate(item.childrenQuestion, true) }
        if (!list.optionList.some(obj => { return obj.select })) { list.show = false }
      }
    },

    inputComplete (item, verify, data) {
      data.show = verify
    },

    beforeClose (action, done) {
      //      未整理
      if (done === true || done === false) {
        this.popDataState = done
      } else {
        if (action === 'confirm' && this.popDataState) {
          if (this.inputModel !== '') {
            if (this.hasActions.parent.questionTypeCode !== 'radio') {
              if (this.hasActions.child.exclusive === 1) {
                this.eliminate([this.hasActions.parent])
              } else {
                this.hasActions.parent.optionList.forEach(obj => {
                  if (obj.exclusive === 1) {
                    obj.select = false
                    if (obj.childrenQuestion && obj.childrenQuestion.length > 0) {
                      this.eliminate(obj.childrenQuestion)
                    }
                  }
                })
              }
            } else {
              this.eliminate([this.hasActions.parent])
            }
            this.inputPopData.txtAnswer = this.inputModel
            this.hasActions.child.select = true
            this.inputPopData.show = true
            this.hasActions.parent.show = true
          }
          done()
        } else if (action === 'cancel') {
          //先查看是否有其他选项已选中
          done()
        } else {
          done(false)
        }
        done(false)
      }
    },

    async prev () {
      Loading.show()
      this.topIndex -= 1
      this.dataList = this.allData[this.topIndex]
      this.answers.pop()
      Loading.close()
    },

    getSubData (data) {
      let pageData = []

      for (let i in data) {
        let question = data[i]
        if (question.popup !== 1 && !question.show || (question.questionTypeCode === 'text' && !question.show)) {
          //            console.log(question)
          //填空题未填写
          this.$set(question, 'motionless', true)
          jumper.jumpByElementId('m' + question.id)
          return false
        } else {
          if (question.questionTypeCode === 'text') {
            pageData.push({
              qid: question.questionId,
              txtAnswer: question.txtAnswer,
              textAnswer: question.txtAnswer
            })
          } else {
            let optAnswers = []
            question.optionList.forEach(obj => {
              if (obj.select) {
                optAnswers.push(obj.id)
                if (obj.childrenQuestion && obj.childrenQuestion.length && obj.childrenQuestion[0].popup === 1) {
                  console.log(obj.childrenQuestion[0], obj, obj.name, question.name)
                  let popupList = this.getSubData([obj.childrenQuestion[0]])
                  pageData = pageData.concat(popupList)
                }
              }
            })
            pageData.push({
              qid: question.questionId,
              optAnswers: optAnswers
            })
          }
        }
      }
      return pageData
    },
    async next (bool) {
      //        let pageData = []
      Loading.show()
      //判断当前分类是否全部答完
      let data = await this.getSubData(this.dataList)
      if (data) {
        this.answers[this.topIndex] = data
        console.log(this.answers)
        if (!bool) {
          setTimeout(() => {
            window.scrollTo(0, 0)
          }, 200)
        }
        // 第四页点提交
        if (bool && this.topIndex === (this.allData.length - 1)) {
          this.$emit('next', this.answers, this.topIndex, true, true)
          return
        } else {
          this.$emit('next', this.answers, this.topIndex)
        }

        if (!bool && this.topIndex < this.allData.length - 1) this.topIndex += 1
        await this.selectState()
      }
      Loading.close()
    },

    moveDown (e) {
      let ch = e.y
      let h = document.body.offsetHeight // 容器高
      if (ch > (h / 2)) {
        jumper.jump(h / 3)
      } else {
        jumper.jump(-(h / 3))
      }
    }
  }
}
</script>

<style lang="scss" scoped>
  @import '../../../assets/style/variables.scss';

  .affix + .conceal {
    visibility: hidden;
  }

  .affix-top + .conceal, .affix-bottom + .conceal {
    display: none;
  }

  .affix-bottom {
    visibility: hidden;
  }

  .affix {
    padding: 0 10px;
    background: #f5f5f5 !important;
    box-sizing: border-box;
  }

  .affix-bottom, .affix-top, .affix {
    z-index: 0
  }

  .selct-wrap {
    padding-bottom: 60px;
  }

  .m-top-box {
    display: flex;
    flex: 1;
    justify-content: center;
    position: relative;
    top: 11px;
    width: 100%;
    height: 22px;
    .m-top-bar {
      display: flex;
      width: 85%;
      height: 22px;
      line-height: 22px;
      font-size: 0;
      text-align: center;
      border-radius: 4px;
      background-color: #d9d9d9;
      overflow: hidden;
      .m-bar {
        position: relative;
        flex: 1;
        font-size: 12px;
        img {
          width: 100%;
          height: 100%;
        }
        .icon {
          position: absolute;
          right: -12px;
          font-size: 24px;
          color: #ffffff;
        }
        .active {
          position: absolute;
          top: 0;
          left: 0;
          right: 0;
          bottom: 0;
          margin: auto;
          color: #ffffff;
        }
      }
      .m-bar.active {
        flex: 0 0 60%;
      }
      .m-bar.active.less {
        flex: 1;
      }
    }
  }

  .m-question {
    background: #f5f5f5;
    padding: 44px 10px 0 10px;
    .m-card {
      border-radius: 8px;
      margin-top: 10px;
      padding: 10px 15px;
      color: #666666;
      background: #ffffff;
      > div {
        display: flex;
        flex-wrap: wrap;
      }
      .m-radio-box {
        width: 100%;
        .m-radio-1 {
          padding: 3px 0;
          margin-bottom: 12px;
          font-size: 16px;
        }
      }
      .m-checkbox {
        display: inline-block;
        /*width: 100%;*/
        line-height: 20px;
        margin-bottom: 12px;
        padding: 7px 5px;
        font-size: 16px;
        border-radius: 17px;
      }
      .m-input {
        width: 300px;
        overflow: hidden;
        display: flex;
        justify-items: center;
        font-size: 16px;
        > div {
          flex: 0 0 70%;
        }
        span {
          height: 35px;
          padding: 5px 0 0 10px;
          flex: 1;
        }
        input {
          padding-left: 20px;
          border-radius: 20px;
          font-size: 16px;
          border: none;
        }

      }
    }
  }

  .m-title {
    padding: 5px;
    background: #ffffff;
    line-height: 24px;
    z-index: 1;
    padding-bottom: 5px;
    span {
      display: inline-block;
      width: 55px;
      height: 20px;
      position: relative;
      top: -3px;
      margin-left: 5px;
      line-height: 18px;
      font-size: 12px;
      border-radius: 11px;
      text-align: center;
      vertical-align: middle;
      border: 1px solid $assertive;
      color: $assertive;
    }
    em {
      line-height: 22px;
      font-size: 16px;
      color: #000000;
    }
  }

  .m-foot {
    position: fixed;
    left: 0;
    bottom: 0;
    width: 100%;
    height: 50px;
    background-color: #ffffff;
    display: flex;
    button {
      z-index: 11;
      flex: 1;
    }
    .m-btn-1 {
      width: 100%;
      height: 50px;
      font-size: 20px;
      background-color: $assertive;
      color: #ffffff;
    }
    .m-btn-prev {
      width: 50%;
      height: 50px;
      font-size: 20px;
      border-radius: 4px 0 0 4px;
      background-color: #cccccc;
      color: #ffffff;
    }
    .m-btn-next {
      width: 50%;
      height: 50px;
      font-size: 20px;
      border-radius: 0 4px 4px 0;
      background-color: $assertive;
      color: #ffffff;
    }
  }

  .m-question {
    .icon {
      z-index: 0;
      font-size: 22px;
      position: relative;
      top: 2px;
    }
    .icon-radiochecked-copy {
      color: $assertive;
    }
    .icon-danxuankuang {
      color: #ccc;
    }
  }

  .m-actions-box {
    width: 100%;
    background-color: #f5f5f5;
    .m-actions {
      width: 100%;
      height: 44px;
      line-height: 44px;
      text-align: center;
      font-size: 14px;
      border-bottom: 1px solid #f5f5f5;
      background-color: #ffffff;
      position: relative;
    }
    .icon-right {
      position: absolute;
      left: 25%;
    }
    .m-affirm {
      margin-top: 10px;
      font-size: 18px;
      background-color: $assertive;
      color: #ffffff;
    }
    .actions-active {
      color: $assertive;
    }
  }

  .m-pop {
    background-color: #f5f5f5;
    .m-pop-title {
      width: 100%;
      height: 40px;
      line-height: 40px;
      font-size: 16px;
      text-align: center;
      background-color: $assertive;
      color: #fff;
    }
    .m-pop-cont {
      padding: 0 15px 15px 15px;
      .m-issue {
        line-height: 24px;
        padding: 10px 0;
        font-size: 16px;
        color: #000000;
      }
    }
    .m-ipt-box {
      width: 100%;
      /*height: 40px;*/
      border: 1px solid $assertive;
      border-radius: 4px;
      overflow: hidden;
      > input {
        width: 100%;
        height: 40px;
        padding-left: 20px;
        font-size: 14px;
        border: none;
      }
    }

  }

  *[calss^='numOfEachRow-'] {
    display: inline-block !important;
  }

  .numOfEachRow-1 {
    flex: 0 0 100%;
  }

  .numOfEachRow-2 {
    flex: 0 0 50%;
  }

  /*.numOfEachRow-3{*/
  /*flex:0 0 100px;*/
  /*}*/
  /*.numOfEachRow-4{*/
  /*flex:0 0 75px;*/
  /*}*/

  .notPass {
    background: #fff8f8 !important;
    .m-input-box /deep/ {
      input.m-input {
        border-bottom: none;
        /*background: transparent !important;*/
      }
    }
  }

  .m-input-box /deep/ {
    .m-input {
      border: 1px solid #ddd;
      padding: 5px 0;
      border-radius: 5px;
      margin: 5px 0;
    }
    .m-input + div {
      width: auto;
    }

  }

  .notPass .m-title:before {
    content: '请完成当前题目';
    display: block;
    height: 50px;
    font-size: 16px;
    text-align: center;
    color: $assertive;
  }

  .notPass .affix-block {
    background: #fff8f8 !important;
  }

  .less {
    background: $dark06;
  }

  .affix-block {
    background: #FFF;
  }

  .affix {
    background: #FFF;
    z-index: 2;
    width: 100%;
    top: 0 !important;
    left: 0;
    .m-title {
      padding: 5px 20px;
    }
  }

  .notPass {
    .m-input-box /deep/ {
      background-color: #fff8f8 !important;
      .m-input {
        padding: 5px 0;
        margin: 5px 0;
      }
      .m-msg {
        background-color: #fff8f8 !important;
      }
    }
    .m-title {
      background: #fff8f8 !important;
    }
  }

  .affix-bottom {
    z-index: 1;
  }

  .questionPic {
    width: 200px;
    display: inline-block;
    margin: 0 auto;
    position: relative;
    left: 50%;
    margin-bottom: 15px;
    transform: translate(-50%);
  }

  .optionsPic img {
    width: 150px;
  }

  .hasPic {
    padding-left: 20px !important;
    border-radius: 8px;
    border: 1px solid #ddd;
    display: flex;
    align-items: center;
    span {
      flex: 1;
      div {
        text-align: center;
        line-height: 1.5;
      }
    }
    div img {
      /*display: flex;*/
      display: block;
      margin: 10px auto;

    }

    /*span img{*/
    /*flex: 0 0 150px;*/
    /*}*/
  }

  .m-input /deep/ {
    .m-msg {
      padding-left: 0px !important;
    }
  }
</style>
